import { render, staticRenderFns } from "./ExtrasDialog.vue?vue&type=template&id=b730ab20&scoped=true&"
import script from "./ExtrasDialog.vue?vue&type=script&lang=js&"
export * from "./ExtrasDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExtrasDialog.vue?vue&type=style&index=0&id=b730ab20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b730ab20",
  null
  
)

export default component.exports